/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const News = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 22 21" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M18 21H3c-1.654 0-3-1.346-3-3V6h3v2H2v10c0 .55.449 1 1 1 .551 0 1-.45 1-1V0h18v17a4.005 4.005 0 0 1-4 4zm0-2c1.103 0 2-.897 2-2V2H6v16c0 .35-.06.687-.171 1zm0-13h-3V4h3zm0 3h-3V7h3zm0 3H8v-2h10zm0 3H8v-2h10zm-5.083-6H8V4h4.917zM10 7h.917V6H10z" />
      </g>
    </svg>
  </span>
);

News.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

News.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default News;
